define('OutSystems/ClientRuntime/modules/Common/RequestUtils',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.formatDataToBeSent = void 0;
    var MAX_SIZE_BYTES = 100 * 1024 * 1024;
    function formatDataToBeSent(data, maxSize) {
        if (maxSize === void 0) { maxSize = MAX_SIZE_BYTES; }
        if ((data === null || data === void 0 ? void 0 : data.length) >= maxSize) {
            return new Blob([data], {
                type: "text/plain",
            });
        }
        else {
            return data;
        }
    }
    exports.formatDataToBeSent = formatDataToBeSent;
});
//# sourceMappingURL=RequestUtils.js.map;
